import React from 'react';
import { SitecoreImageField } from 'components/sitecore-fields';
import {
    LiveArrowControl,
    controlTypes,
    modeTypes,
} from 'components/live-arrow-control';
import {
    EVENT_DEVICE_TYPE_CHANGED,
} from 'general/js/app';
import eventBus from 'general/js/event-bus';
import { handleMastercardRegistrationEnforce } from '../helpers/toch-helpers';
import TOCHImageGalleryTiles from './TOCHImageGalleryTiles';
import { addQueryParams, redirectTo } from '../../../../general/js/utils';
import { QueryConstants } from '../../../../general/js/utils/query-constants';

class MastercardPromoPanel extends React.Component {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    componentWillUnmount() {
        eventBus.removeListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    onDeviceTypeChanged = (oldDeviceType, newDeviceType) => {
        this.setState({
            deviceType: newDeviceType
        });
    }

    onClickPrevBtn = () => {
        this.gallery.goTo('prev');
    }

    onClickNextBtn = () => {
        this.gallery.goTo('next');
    }

    getNode = (node) => {
        this.gallery = node;
    }

    shouldRenderCarousel(tiles) {
        if (tiles === null) return false;

        return tiles.length > 1;
    }

    onClick = (tile) => {
        const {
            mastercardRegistrationPage
        } = this.props.options;
        const { isMastercardAdvantageContent } = tile;

        if (isMastercardAdvantageContent && handleMastercardRegistrationEnforce(this.props.options)) {
            redirectTo(addQueryParams(mastercardRegistrationPage.url, [
                {
                    key: QueryConstants.REDIRECT_URL,
                    value: tile.link.url
                }
            ]));
            return;
        }

        redirectTo(tile.link.url);
    }

    render() {
        const {
            mastercardLogo,
            mastercardText,
            mastercardBranding,
            title,
            subtitle,
            tiles,
            mastercardPromoPanelId,
        } = this.props.options;

        const hasCarousel = this.shouldRenderCarousel(tiles);

        return (
            <div id={mastercardPromoPanelId}>
                {mastercardBranding !== null &&
                    <div className="multimedia-carousel__bg">
                        <SitecoreImageField img={mastercardBranding.background} className='multimedia-carousel__bg--desktop'/>
                        <SitecoreImageField img={mastercardBranding.mobileBackgroung} className='multimedia-carousel__bg--modile'/>
                    </div>
                }
                <div className='container'>
                    <div className='multimedia-carousel__header'>
                        <div>
                            {mastercardBranding !== null &&
                            <div>
                                <div className='mastercard-branding'>
                                    <div className='mastercard-branding--title'>{mastercardText}</div>
                                    <SitecoreImageField img={mastercardLogo} className='mastercard-branding--logo' />
                                </div>
                                <h3 className='multimedia-carousel__title'>{title}</h3>
                                <div className='multimedia-carousel__subtitle'>{subtitle}</div>
                            </div>
                            }
                            <div className='multimedia-carousel__desktop-controls'>
                                {
                                    hasCarousel &&
                                <div className='carousel-controls carousel-controls--multimedia'>
                                    <div className='carousel-controls__prev-btn'>
                                        <LiveArrowControl
                                            mode={modeTypes.carousel}
                                            type={controlTypes.prev}
                                            onClickPrevBtn={this.onClickPrevBtn}
                                        />
                                    </div>
                                    <div className='carousel-controls__next-btn'>
                                        <LiveArrowControl
                                            mode={modeTypes.carousel}
                                            type={controlTypes.next}
                                            onClickNextBtn={this.onClickNextBtn}
                                        />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    <TOCHImageGalleryTiles tiles={tiles} getNode={this.getNode} hasCarousel={hasCarousel} onClick={this.onClick} />
                </div>
            </div>
        );
    }
}

export default (MastercardPromoPanel);
